import axios from "axios";
import {  LIST_BANKS,BANK,BASE_URL, LEAN_URL, DELETE, DELETE_BANK, ACCOUNTS, FETCH_BANK, PRIORITY_BANK} from "../util/constants";
import { sendRequest } from "./base";

export const getAllBanks = async (data, page, token, limit) => {
  const Authorization = `Bearer ${token}`;
  try {
    return sendRequest(data, "POST", `${LIST_BANKS}?page=${page + 1}&pageSize=${limit}`, { Authorization });
  } catch (err) {
    return err;
  }
};

export const addBank = async (data, token) => {
  const Authorization = `Bearer ${token}`;
  try {
    return sendRequest(data, "POST", ACCOUNTS, { Authorization });
  } catch (error) {
    return error;
  }
};

export const editBank = async (data, id, token) => {
  const Authorization = `Bearer ${token}`;
  try {
    return sendRequest(data, "PUT", `${ACCOUNTS}/update?accountId=${id}`, {Authorization,
    });
  } catch (error) {
    return error;
  }
};

export const getBankById = async (id, token) => {
  const Authorization = `Bearer ${token}`;
  try {
    return sendRequest(null, "GET", `${FETCH_BANK}/?accountId=${id}`, { Authorization });
  } catch (err) {
    return err;
  }
};

export const deleteBank = async (id, token) => {
  const Authorization = `Bearer ${token}`;
  try {
    return sendRequest({}, "DELETE", `${DELETE_BANK}?accountId=${id}`, { Authorization });
  } catch (err) {
    return err;
  }
};
export const searchBanks = async (data, SearchValue, token) => {
  const Authorization = `Bearer ${token}`;
  try {
    return sendRequest(
      data,
      "POST",
      `${LIST_BANKS}?searchBy=${SearchValue}`,
      {
        Authorization,
      }
    );
  } catch (e) {
    return e;
  }
};

export const getLeanBankList = async () => {
  try {
    return sendRequest(null, "GET", 'leanBanks');
  } catch (err) {
    return err;
  }
};

export const setPriorityAccount = async (id, token) => {
  const Authorization = `Bearer ${token}`;
  try {
    return sendRequest(null, "PUT", `${PRIORITY_BANK}/?id=${id}`, { Authorization });
  } catch (err) {
    return err;
  }
};